var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.895182 2.34686C0.986849 2.46603 6.15685 9.06603 6.15685 9.06603V14.5752C6.15685 15.0794 6.56935 15.4919 7.08268 15.4919H8.92518C9.42935 15.4919 9.85102 15.0794 9.85102 14.5752V9.05686C9.85102 9.05686 14.8835 2.62186 15.1219 2.32853C15.3602 2.0352 15.3327 1.74186 15.3327 1.74186C15.3327 1.2377 14.9202 0.825195 14.4068 0.825195H1.59185C1.03268 0.825195 0.666016 1.2652 0.666016 1.74186C0.666016 1.9252 0.721016 2.1452 0.895182 2.34686Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.4eef0de29b77f4b3937430717bb1ba03.svg";
export { ForwardRef as ReactComponent };